import styled from 'styled-components';

type Props = {
  title: string;
};

const Title = styled.h2`
  ${(props) => props.theme.font.h2}

  color: ${(props) => props.theme.colors.secondary};
`;

const Divider = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #e0e0e0;
  width: 50%;
  @media ${(props) => props.theme.breakpoints.smd} {
    width: 100%;
  }
`;

const SectionTitle: React.FC<Props> = ({ title }) => {
  return (
    <>
      <Title
        key={title.substring(0, 10) + new Date().getTime()}
        as="h2"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      ></Title>
      <Divider />
    </>
  );
};

export default SectionTitle;
